import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportRestockbyCaps } from 'utils/breadcrumbInfo';
import { getRestockByCaps, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getProductCategories } from 'actions/EntityActions';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import PageHeader from 'screens/components/basic/PageHeader';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';
import Body from './Body';
import Header from './Header';

class RestockbyCaps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false
        };
        this.showBody = this.showBody.bind(this);
    }

    componentWillMount() {
        this.props.getProductCategories(this.props.branchId || parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')));
    }
    
    getCategoryOptions = () => {
        return (this.props.category.list || []).map(item => {
            return {
                text: item.name,
                value: item.id.toString(),
                isCannabis: item.isCannabis
            };
        });
    }

    getReport = () => {
        let model = {
            beginDate: this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY'),
            endDate: this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY'),
            branch: this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch,
            pageNumber: this.state.activePage,
            pageSize: this.state.itemsPerPage,
            isCannabis: this.props.isCannabis,
            category: this.props.categoryFilter || 0
        }
        this.props.getRestockByCaps(model);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let pageNumber = 1;
        let category = this.props.categoryFilter || 0;
        let isCannabis = this.props.isCannabis;
        let pageSize = 9999;
        this.props.getCsvReport(`reports/excel/restock?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}&pageNumber=${pageNumber}&pageSize=${pageSize}&isCannabis=${isCannabis}&category=${category}`, "restockbyCaps");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    render() {
        const totalRow = this.props.restockbyCaps ? this.props.restockbyCaps.total ? this.props.restockbyCaps.total > 0 ? this.props.restockbyCaps.total : 0 : 0 : 0;
        return (
            <Grid headerContent={reportRestockbyCaps}>
                <PageHeader title={LOOKUP.report.restockbyCaps.text}
                    description={LOOKUP.report.restockbyCaps.description}
                />
                <Header
                    branchOptions={this.props.branchOptions}
                    filter={this.filter}
                    productCategories={this.getCategoryOptions()}
                    isCannabisOptions={this.props.isCannabisOptions}
                    isCannabis={this.props.isCannabis}
                    downloadReport={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <React.Fragment>
                        <DateCurrentDisplay/>
                        <CardSimple>
                            <Body restockbyCaps={this.props.restockbyCaps} />
                            <Pagination
                                length={totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    </React.Fragment>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let isCannabis = [
        {
            text: "All", value: "2"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non-Cannabis", value: "0"
        }
    ];
    return {
        branchOptions: branchOptions,
        beginDate: state.form.RestockbyCapsBeginDate,
        endDate: state.form.RestockbyCapsEndDate,
        restockbyCaps: state.reports.restockbyCaps,
        isCannabisOptions: isCannabis,
        category: state.entity.productCategories,
        categoryFilter: state.form.RestockbyCapsCategoryOption,
        isCannabis: state.form.RestockbyCapsIsCannabis,
        loggedBranch: state.common.branchId,
        branch: state.form.OrderListBranchOption,
        selectedBranch: state.form.InventoryAgeBranchOption
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getRestockByCaps: (model) => dispatch(getRestockByCaps(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductCategories: (branchId) => dispatch(getProductCategories(branchId)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RestockbyCaps);